import { AIRunStatus } from '../shared/brand/aiProgress';

/**
 * Where a finished creation run sends the user, and when.
 *
 * Kept out of `MatterForm` because the decision is the whole bug: the old
 * navigation was a `history.push` at the tail of a PubSub callback, behind a
 * mounted-flag that StrictMode had already cleared, building its path from a
 * uuid it never checked. Each of those three is a line here with a test on it.
 */

/** The route that opens a matter. `/matters/:matterId` - see `PrivateRoutes`. */
export function matterDetailRoute(uuid: string): string {
  return `/matters/${uuid}`;
}

/**
 * `null` when there is nowhere to go - no uuid, or a uuid that would render
 * as the string "undefined". `/matters/undefined` MATCHES the detail route,
 * so a missing id doesn't fail loudly: it loads a matter page for a matter
 * that cannot exist.
 */
export function createdMatterRoute(uuid: string | null | undefined): string | null {
  const trimmed = typeof uuid === 'string' ? uuid.trim() : '';
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null') return null;
  return matterDetailRoute(trimmed);
}

/**
 * A run that has produced a matter to open. Both terminal successes count —
 * a run that finished with some documents unreadable still created the
 * matter, and leaving the user on the wizard would lose it.
 */
export function isCreationSuccess(status: AIRunStatus): boolean {
  return status === 'completed' || status === 'completed_with_errors';
}

/** The one call the navigation effect makes: the route to go to, or null. */
export function createdMatterDestination(
  status: AIRunStatus,
  uuid: string | null | undefined,
  alreadyNavigated: boolean,
): string | null {
  if (alreadyNavigated) return null;
  if (!isCreationSuccess(status)) return null;
  return createdMatterRoute(uuid);
}
